import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function Hero() {
  return <section className="py-8 sm:py-10 px-4 bg-brand-cream" data-id="element-103" data-mp="ej4mbu3165dv">
      <div className="max-w-3xl mx-auto text-center" data-id="element-104" data-mp="9kjwmolen43o">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-petrol/10 border border-brand-petrol/20 text-brand-petrol font-semibold text-xs sm:text-sm mb-4" data-id="element-105" data-mp="9lbkteco9zjx">
          <span data-id="element-106" data-mp="12862k3i3uktp">⚡</span>
          <span data-id="element-107" data-mp="127eereur1rdz">VALIDATED COACHING SYSTEM</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-brand-graphite leading-tight mb-3" data-id="element-108" data-mp="xbfmvha7pr8t">
          The Complete Operating System for Functional Training Coaches
        </h1>

        <p className="text-base sm:text-lg text-brand-graphite/80 leading-relaxed mb-4 max-w-2xl mx-auto" data-id="element-109" data-mp="nbexpepnwgwp">
          Stop building sessions from scratch, reclaim your time, and elevate
          your coaching — without the exhaustion of programming everything
          manually.
        </p>

        <div className="inline-block bg-brand-gold/20 border-2 border-brand-gold px-4 py-1.5 rounded-lg mb-5" data-id="element-110" data-mp="3j9kbrdwi3lh6">
          <p className="font-bold text-brand-petrol text-base sm:text-lg" data-id="element-111" data-mp="3o6aru18b2h2l">
            FUNCTIONAL PRO™ 6-in-1 Complete System
          </p>
        </div>

        <div className="mb-5" data-id="element-112" data-mp="3e95zfjnv9pdc">
          <a href="#pricing" className="block cursor-pointer" data-id="element-113" data-mp="3e8eh3aja5o50">
            <img src="https://cdn.magicpatterns.com/uploads/xri7Vdckrt4sTKeQinh8Pe/ChatGPT-Image-12-jun-2026_-22_58_43.webp" alt="FUNCTIONAL PRO 6-in-1 Complete System" className="w-full h-auto object-contain max-w-md sm:max-w-lg mx-auto hover:scale-105 transition-transform duration-300" data-id="element-114" data-mp="30iazwxz9ckmf" />
          </a>
        </div>

        <div className="mb-4" data-id="element-115" data-mp="2vgu0l6wf967y">
          <CTAButton className="max-w-md mx-auto" data-id="element-116" data-mp="2hjf8tvip4mct">
            🚀 YES, I WANT MY SYSTEM NOW
          </CTAButton>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm text-brand-graphite/70" data-id="element-117" data-mp="2ljpch1j0n0oi">
          <div className="flex items-center gap-1" data-id="element-118" data-mp="s3mcu1g2bwxu">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-119" data-mp="nbl3anaa4kbi" />
            <span className="font-semibold" data-id="element-120" data-mp="n9i4bdr5fgun">
              4.9/5 — Verified Professional Reviews
            </span>
          </div>
          <span className="hidden sm:inline" data-id="element-121" data-mp="ddngm482ivl0">•</span>
          <div className="flex items-center gap-1" data-id="element-122" data-mp="deyk02xlq1bl">
            <Shield className="w-4 h-4 text-brand-petrol" data-id="element-123" data-mp="1b15olctwntny" />
            <span className="font-semibold" data-id="element-124" data-mp="1ayji7gir3k7b">7-Day Guarantee — Zero Risk</span>
          </div>
        </div>
      </div>
    </section>;
}